import { Link } from 'react-router-dom';

interface VideoCardProps {
  slug: string;
  title: string;
  thumbnail: string;
  duration: string;
  views: number;
  date: string;
  rating: number;
  category?: string;
}

export default function VideoCard({
  slug,
  title,
  thumbnail,
  duration,
  views,
  date,
  rating,
  category,
}: VideoCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-video overflow-hidden bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded-md whitespace-nowrap">
          {duration}
        </span>
        {rating >= 9.5 && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            高分
          </span>
        )}
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500 flex-wrap">
          <span className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            {formatViews(views)}
          </span>
          <span className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500"></i>
            </div>
            {rating}
          </span>
          <span>{date}</span>
        </div>
        {category && (
          <span className="inline-block mt-2 px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md">
            {category}
          </span>
        )}
      </div>
    </Link>
  );
}